export default __webpack_public_path__ + "83535bbcf83b597963ce3a9bd3b7df95.svg";